<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Guest Editors of the Best American Essays</a></p>
<p class="toc sub"><a href="#/front02">Copyright</a></p>
<p class="toc sub"><a href="#/front03">Foreword</a></p>
<p class="toc sub"><a href="#/front04">Introduction</a></p>
<p class="toc"><a href="#/c01">ELIZABETH ALEXANDER: The Trayvon Generation</a></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample">HILTON ALS: Homecoming</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">MOLLY MCCULLY BROWN: The Broken Country</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">AGNES CALLARD: Acceptance Parenting</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">GABRIELLE HAMILTON: The Kitchen Is Closed</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">TONY HOAGLAND: Bent Arrows: On Anticipation of My Approaching Disappearance</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">GREG JACKSON: Vicious Cycles</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">RUCHIR JOSHI: Clarity</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">AMY LEAC: Oh Latitudo</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">PATRICIA LOCKWOOD: Insane After Coronavirus?</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">BARRY LOPEZ: Love in a Time of Terror</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">JESSICA LUSTIG: What I Learned When My Husband Got Sick with Coronavirus</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">DAWN LUNDY MARTIN: What Money Can’t Buy</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">CLAIRE MESSUD: Two Women</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">WESLEY MORRIS: My Mustache</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">BETH NGUYEN: Apparent</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">FINTAN O’TOOLE: The Designated Mourner</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">MAX READ: Going Postal</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">DARIEL SUAREZ: In Orbit</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">JESMYN WARD: Witness and Respair</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Contributors’ Notes</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Notable Essays and Literary Nonfiction of 2020</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Notable Special Issues of 2020</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Read More from the Best American Series</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">Connect on Social Media</span></p>
<p class="toc sub"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?85b2aa34